import { compactValue } from "@/lib/screen-class";

/**
 * Minimum height of a landing page section. From `md` every section fills the window. Below `md` a section is as
 * high as its content: on a tablet in portrait a short section otherwise left most of a screen empty.
 */
export const COMPACT_SECTION_MIN_HEIGHT = compactValue("auto", "100%");

/**
 * Side padding of a section with its own background colour. The colour reaches the edge of the page body, so the
 * text keeps a distance to it on every screen; from `lg` the desktop padding applies.
 */
export const COLORED_SECTION_PX = { xs: 2, md: 3, lg: 10 };
